module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Underworld-Awakening.7d6e4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Underworld-Awakening.jpg
// module id = 7KEk
// module chunks = 0